import { Component, EventEmitter, Input, Output, OnInit, OnChanges, NO_ERRORS_SCHEMA } from '@angular/core';
import { ExportDataService } from '../../../../shared/services/export-data.service';
import { MaintenanceService } from '../../../../techopsv4/services/maintenanceService';
import { MatTableDataSource, MatTable, MatHeaderRowDef, MatHeaderRow, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatRowDef, MatRow } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import { Location, NgClass, CurrencyPipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import _ from 'lodash';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { FormsModule } from '@angular/forms';
import { DropdownWithSearchComponent } from '../../../../shared/elements/dropdown-with-search/dropdown-with-search.component';
import { HierarchyDropdownComponent } from '../../../../shared/elements/hierarchy-dropdown/hierarchy-dropdown.component';
import { LoaderComponent } from '../../../../shared/elements/loader/loader.component';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { BillionsToBMillionsToMThousandsToK } from '../../../../shared/pipe/billionsToB-millionsToM-thousandsToK.pipe';


@Component({
    selector: 'app-capital-investment-summary-leader',
    templateUrl: './capital-investment-summary-leader.component.html',
    styleUrl: './capital-investment-summary-leader.component.css',
    imports: [MatSlideToggle, FormsModule, DropdownWithSearchComponent, HierarchyDropdownComponent, LoaderComponent, MatTable, MatHeaderRowDef, MatHeaderRow, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatIconButton, MatIcon, MatCellDef, MatCell, NgClass, MatRowDef, MatRow, CurrencyPipe, BillionsToBMillionsToMThousandsToK],
    schemas: [NO_ERRORS_SCHEMA],
})
export class CapitalInvestmentSummaryLeaderComponent implements OnChanges, OnInit {
  checked = true;
  @Input() capitalDemandRecords: any[];
  @Output() toggleChanged = new EventEmitter<boolean>();
  disableReset: boolean = true;
  TABLE_COLUMNS: any = [
    {
      key: 'department_leader',
      labelKey: "department_leader",
      label: 'Department Leader',
      width: '35% !important',
      borderRight: '2px solid lightgray',
      paddingLeft: '24px !important',
    },
    {
      key: 'ucmg_count',
      labelKey: "ucmg_count",
      label: 'UCMG Count',
      width: '11% !important',
      textAlign: 'center',
      borderRight: '2px solid lightgray',
    },
    {
      key: 'leader_ot_allocation',
      labelKey: "leader_ot_allocation",
      label: 'Leader OT Allocation',
      width: '7% !important',
      textAlign: 'center',
      legendColor: '#1E3E72',
      parentObj: 'costs',
    },
    {
      key: 'totalRunRate',
      labelKey: "totalRunRate",
      label: 'Leader Run Rate',
      width: '7% !important',
      textAlign: 'center',
      legendColor: '#1E3E72',
      parentObj: 'costs',
    },
    {
      key: 'leader_ot_actuals',
      labelKey: "leader_ot_actuals",
      label: 'Leader OT Actuals',
      width: '7% !important',
      textAlign: 'center',
      legendColor: '#1E3E72',
      parentObj: 'costs',
    },
    {
      key: 'leader_variance',
      labelKey: "leader_variance",
      label: 'Leader Variance',
      width: '7% !important',
      textAlign: 'center',
      legendColor: '#A2D1EA',
      parentObj: 'costs',
    },
  ];
  hierarchyDropdownConfig = {
    parentfield: ['leader_level_1_msid', 'leader_level_1'],
    firstchildfield: ['leader_level_2_msid', 'leader_level_2'],
    secondchildfield: ['leader_level_3_msid', 'leader_level_3', 'children'],
    firstchildkey: 'children',
    secondchildkey: 'children',
  };
  mismatchLeadersMSIDs: any[] = [];
  expandCollapseAll: boolean = false; // Default to collapsed
  isfilterapplied: boolean = false;
  remainingOptumLabour: number;
  exportToExcel: number = 1;
  oldData: any;
  leaderNames: string[] = [];
  leaderdropdwnDataSource: any[] = [];
  selectValues: any[];
  resetTrigger: number = 0;
  flattenedArr: any;
  filteredData: any;
  hierarchicalTableData: any;
  convertedData: any;
  existingNames: Set<string> = new Set();
  capitalDemandLeaderResponse = [];
  disableMultiSelect: boolean;
  ucmgYear: any;
  yearList: { name: number; }[];
  statusList: { name: string; }[];
  selectedStatusList: { name: string; }[];
  dataSourceDetailsOTLabor: MatTableDataSource<any>;
  showLoader: boolean;
  selectedLeaders: any = [];
  selectedYr: any;
  displayedColumns: any;
  L1sTotalOT: number;
  selectedLeadersdetails: any[];
  selectedL3Count: number;
  selectedL2Count: number;
  disableSearch:boolean=true;
  showKPI: boolean = false;
  kpidatasource: any;
  constructor(
    public maintenanceService: MaintenanceService,
    public exportService: ExportDataService,
    private router: Router,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private toaster: ToastrService,
  ) {
   }


  /**
   * Initializes the component by setting up year and status lists,
   * default selections, and fetching the leader hierarchy list.
   */
  ngOnInit() {
    this.yearList = [{ name: new Date().getFullYear() }, { name: new Date().getFullYear() + 1 }];
    this.statusList = [{ name: 'Active' }, { name: 'Inactive' }];
    this.selectedStatusList = [...this.statusList];
    this.selectValues = [];
    this.disableMultiSelect = false;
    this.selectedYr = this.yearList[0];
    this.getLeaderHierarchyList();
    this.displayedColumns = this.TABLE_COLUMNS.map((column) => column.key);
    this.activatedRoute.queryParams.subscribe(params => {

      if (params.fiscalYear || params.selectedStatus) {
      if(localStorage.getItem('filteredData')){
        this.showKPI = true;
        this.expandCollapseAll = false; // Reset expand/collapse state on init
        this.restoreStateFromQueryParams(params);
        this.convertedData = JSON.parse(localStorage.getItem('filteredData') || '[]');
        this.filteredData = this.getFilteredData(this.convertedData);
        this.disableSearch = true;
        this.disableReset = false;
      }
      }
    });


  }

  ngOnChanges() {
    this.expandCollapseAll = false; // Reset expand/collapse state on changes

  }

    private restoreStateFromQueryParams(params: any): void {
    if (params['fiscalYear']) {
      const yearToFind = params['fiscalYear'];
      const yearIndex = this.yearList.findIndex(year => year.name === parseInt(yearToFind, 10));
      this.ucmgYear = this.yearList[yearIndex];
    }

    // Handle investment status - store for passing to child components
    if (params['selectedStatus'] || localStorage.getItem('capitalDemandLeaderSelectedstatus')) {
      const statusArray = localStorage.getItem('capitalDemandLeaderSelectedstatus') ? JSON.parse(localStorage.getItem('capitalDemandLeaderSelectedstatus') || '[]') : [];
      // Clear selectedStatusList first
      this.selectedStatusList = [];

      // Only add items from statusList that exist in statusArray
      statusArray.forEach(statusItem => {
        const matchingIndex = this.statusList.findIndex(listItem => listItem.name === statusItem.name);
        if (matchingIndex !== -1) {
          // Only push the matching item from statusList if it exists in statusArray
          this.selectedStatusList.push(this.statusList[matchingIndex]);
        }
      });
      this.leaderOTAllocationKPI = localStorage.getItem('capitalDemandLeaderKPIValues') ? JSON.parse(localStorage.getItem('capitalDemandLeaderKPIValues') || '{}').leaderOTAllocationKPI : { label: 'Leader OT Allocation', value: 0, format: 'currency' };
      this.leaderVarianceKPI = localStorage.getItem('capitalDemandLeaderKPIValues') ? JSON.parse(localStorage.getItem('capitalDemandLeaderKPIValues') || '{}').leaderVarianceKPI : { label: 'Leader Variance', value: 0, format: 'currency' };
      this.leaderRunRateKPI = localStorage.getItem('capitalDemandLeaderKPIValues') ? JSON.parse(localStorage.getItem('capitalDemandLeaderKPIValues') || '{}').leaderRunRateKPI : { label: 'Leader Run Rate', value: 0, format: 'currency' };
      this.selectValues = localStorage.getItem('selectedHierarchyItems') ? JSON.parse(localStorage.getItem('selectedHierarchyItems') || '[]') : [];

    }


    }

  expandAll() {
    this.expandCollapseAll = true;
    this.convertedData.forEach(group => {
      group.forEach(leader => leader.expanded = true);
    });
    this.filteredData = this.getFilteredData(this.convertedData);
  }

  collapseAll() {
    this.expandCollapseAll = false;
    this.convertedData.forEach(group => {
      group.forEach(leader => leader.expanded = false);
    });
    this.filteredData = this.getFilteredData(this.convertedData);
  }

  toggleExpanded(element: any) {
    let found = false;
    for (let i = 0; i < this.convertedData.length; i++) { //for each array
      const index = this.convertedData[i].findIndex(item =>
        item.Leader_Name === element.Leader_Name &&
        item.DepartmentIDName === element.DepartmentIDName && item.level === element.level
      );
      if (index !== -1) {
        this.convertedData[i][index].expanded = !this.convertedData[i][index].expanded;

        // If the element is an L1 leader and is being collapsed, set expanded to false for all its children
        if (element.level === 'L1' && !this.convertedData[i][index].expanded) {
          for (let j = index + 1; j < this.convertedData[i].length; j++) {
            if (this.getLevelInt(this.convertedData[i][j].level) > this.getLevelInt(element.level)) {
              this.convertedData[i][j].expanded = false;
            } else {
              break;
            }
          }
        }

        found = true;
        break;
      }
    }
    if (found) {
      this.filteredData = this.getFilteredData(this.convertedData);
      this.dataSourceDetailsOTLabor = new MatTableDataSource(this.filteredData);

      // Check if any leader is expanded and update the expandCollapseAll flag
      this.expandCollapseAll = this.convertedData.some(group => group.some(leader => leader.expanded));
    } else {
      console.log("Element not found");
    }
  }

  shouldShowExpandIcon(element: any): boolean {
    if (!element || !Array.isArray(this.convertedData)) {
      return false;
    }
    if (!this.convertedData) {
      return false;
    }
    let curElementIndex; //get index of curElement
    const curLevel = this.getLevelInt(element.level); //get level of curElement
    const deepCopy = this.convertedData;
    for (let i = 0; i < this.convertedData.length; i++) {
      curElementIndex = this.convertedData[i].findIndex((item: any) => item.Leader_Name === element.Leader_Name && item.department_id_name === element.department_id_name && item.level === element.level); //find current element
      if (curElementIndex !== -1) {
        const remainingElements = deepCopy[i].slice(curElementIndex + 1); //remove current item in tree and everything before
        if (!remainingElements || remainingElements.length === 0) { return false } //if nothing after return false
        if (this.getLevelInt(remainingElements[0].level) <= curLevel) {
          return false;
        } else {
          return true;
        }
      }
    }
    return false;
  }

    private transformNodeRecursively(item: any, currentLevel: number = 1): any {
    if (!item || typeof item !== 'object') {
      return null;
    }

    // Check if the item has the required properties for this level
    const nameKey = `leader_level_${currentLevel}`;
    const msidKey = `leader_level_${currentLevel}_msid`;

    // If the item doesn't have both name and MSID at this level, it's invalid
    if (!item[msidKey] && !item[nameKey]) {
      return null;
    }

    // Extract the name and MSID for this level
    const name = item[nameKey] || '';
    const id = item[msidKey] || '';

    // Create the node structure
    const transformedNode: any = {
      [nameKey]: name,
      [msidKey]: id,
      name: name,
      id: id ? `${id}:${nameKey}` : `L${currentLevel}:${name}`,
      children: []
    };

    // Recursively transform children if they exist
    if (Array.isArray(item.children) && item.children.length > 0) {
      transformedNode.children = item.children
        .map(child => this.transformNodeRecursively(child, currentLevel + 1) || null)
        .filter(child => child !== null); // Remove any null results
    }

    return transformedNode;
  }
  generateDropdownData(data: any[]): any[] {
    if (!Array.isArray(data) || data.length === 0) {
      return [];
    }
    return data
      .map(item => this.transformNodeRecursively(item))
      .filter(item => item !== null);
  }

  private getExcludedLeaderPaths(event: any): any[] {
    if (!Array.isArray(event) || !event[0] || typeof event[0] !== 'object') {
      return [];
    }
    return event[0].__excludePaths || [];
  }

  private isLeaderPathExcluded(excludedPaths: any[], l1Name: string, l2Name: string, l3Name: string): boolean {
    return excludedPaths.some(path => path.L1 === l1Name && path.L2 === l2Name && path.L3 === l3Name);
  }

  private buildSelectedLeaderSet(excludedPaths: any[]): Set<string> {
    const selectedList = new Set<string>();

    this.leaderdropdwnDataSource.forEach(l1 => {
      l1.children.forEach(l2 => {
        l2.children.forEach(l3 => {
          if (!this.isLeaderPathExcluded(excludedPaths, l1.leader_level_1, l2.leader_level_2, l3.leader_level_3)) {
            selectedList.add(`${l1.leader_level_1}-${l2.leader_level_2_msid}-${l3.leader_level_3_msid}`);
          }
        });
      });
    });

    return selectedList;
  }

  private buildLeaderSelectionForL2(l1: any, l2: any, excludedPaths: any[], selectedList: Set<string>): any {
    const subChildren = l2.children
      .filter(sub => !this.isLeaderPathExcluded(excludedPaths, l1.leader_level_1, l2.leader_level_2, sub.leader_level_3))
      .map(sub => sub.leader_level_3_msid);

    if (!subChildren.length) {
      return null;
    }

    return {
      leader_level_1_msid: l1.leader_level_1_msid,
      leader_level_2_msid: l2.leader_level_2_msid,
      children: subChildren,
      selectedList: selectedList
    };
  }

  private buildAllSelectedLeaders(excludedPaths: any[], selectedList: Set<string>): any[] {
    return this.leaderdropdwnDataSource
      .flatMap(l1 => l1.children.map(l2 => this.buildLeaderSelectionForL2(l1, l2, excludedPaths, selectedList)))
      .filter(item => item !== null);
  }

  setAllLeaderValues(event) {
    const excludedPaths = this.getExcludedLeaderPaths(event);
    const selectedList = this.buildSelectedLeaderSet(excludedPaths);
    const allLeaders = this.buildAllSelectedLeaders(excludedPaths, selectedList);

    this.setSelectedValues(allLeaders, 'leader');
  }
  setSelectedLeaderValues(event){
    if(event && event.length > 0){
      if(event[0].__selectAll__){
        return this.setAllLeaderValues(event);
      }
      const transformedLeaders = this.transformLeaderHierarchy(event);
      if(transformedLeaders && transformedLeaders.length > 0){
        this.selectValues = transformedLeaders;
      } else {
        this.selectValues = [];
      }
    } else {
      this.selectValues = [];
    }
    this.setSelectedValues(this.selectValues, 'leader');
  }

  /**
   * Transforms an array of leader name objects into hierarchical MSID objects
   * Groups by L1 and L2, fetching MSID values from the leaderdropdwnDataSource
   */
  private transformLeaderHierarchy(inputEvents: any[]): any[] {
    // Map to store unique L1 + L2 + L3 combinations
    const groupedData = new Map<string, any>();
    const selectedList = new Set<string>();
    inputEvents.forEach(event => {
      const l1Name = event.L1?.trim();
      const l2Name = event.L2?.trim();
      const l3Name = event.L3?.trim();
      const l1Entry = this.findLeaderByName(this.leaderdropdwnDataSource, l1Name, 1);
      const l1Msid = l1Entry.leader_level_1_msid;
      const l2Entry = this.findL2ByName(l1Entry.children, l2Name);
      const l2Msid = l2Entry.leader_level_2_msid;

      const l3Entry = this.findL3ByName(l2Entry.children, l3Name);
      const l3Msid = l3Entry.leader_level_3_msid;
      selectedList.add(`${l1Name}-${l2Msid}-${l3Msid}`); // Store the selected combination

      const groupKey = `${l1Msid}|${l2Msid}`;

      if (!groupedData.has(groupKey)) {
        groupedData.set(groupKey, {
          leader_level_1_msid: l1Msid,
          leader_level_2_msid: l2Msid,
          children: new Set<string>(),
          selectedList: selectedList,
          allL3sSelected: false,
          allL2sSelected: false
        });
      }

      const groupEntry = groupedData.get(groupKey);
      groupEntry.children.add(l3Msid);
    });

    // Convert Map to array and process selections
    const result = Array.from(groupedData.values()).map(item => ({
      leader_level_1_msid: item.leader_level_1_msid,
      leader_level_2_msid: item.leader_level_2_msid,
      children: Array.from(item.children),
      selectedList: selectedList,
      allL3sSelected: this.checkAllL3sSelected(item),
      allL2sSelected: this.checkAllL2sSelected(item)
    }));

    return result;
  }

  /**
   * Finds a leader by name in the hierarchy at a specific level
   */
  private findLeaderByName(hierarchy: any[], name: string, level: number): any {
    if (!hierarchy || !Array.isArray(hierarchy)) {
      return null;
    }

    for (const item of hierarchy) {
      const levelKey = `leader_level_${level}`;
      if (item[levelKey] && item[levelKey].trim() === name.trim()) {
        return item;
      }
    }
    return null;
  }

  /**
   * Finds L2 leader by name within L1's children
   */
  private findL2ByName(l2Children: any[], name: string): any {
    if (!l2Children || !Array.isArray(l2Children)) {
      return null;
    }

    for (const item of l2Children) {
      if (item.leader_level_2 && item.leader_level_2.trim() === name.trim()) {
        return item;
      }
    }
    return null;
  }

  /**
   * Finds L3 leader by name within L2's children
   */
  private findL3ByName(l3Children: any[], name: string): any {
    if (!l3Children || !Array.isArray(l3Children)) {
      return null;
    }

    for (const item of l3Children) {
      if (item.leader_level_3 && item.leader_level_3.trim() === name.trim()) {
        return item;
      }
    }
    return null;
  }

  /**
   * Determines if all L3s under the L2 are selected
   */
  private checkAllL3sSelected(groupItem: any): boolean {
    // Find the L1 entry
    const l1Entry = this.leaderdropdwnDataSource.find(
      item => item.leader_level_1_msid === groupItem.leader_level_1_msid
    );

    if (!l1Entry || !l1Entry.children) {
      return false;
    }

    // Find the L2 entry within L1
    const l2Entry = l1Entry.children.find(
      item => item.leader_level_2_msid === groupItem.leader_level_2_msid
    );

    if (!l2Entry || !l2Entry.children) {
      return false;
    }

    // Get all L3 MSIDs under this L2
    const allL3MSIDs = l2Entry.children
      .map(item => item.leader_level_3_msid)
      .filter(id => id !== null && id !== undefined);

    // Check if all L3s are in the selected children
    const selectedChildren = new Set(groupItem.children);

    return allL3MSIDs.length > 0 &&
           allL3MSIDs.every(msid => selectedChildren.has(msid));
  }

  /**
   * Determines if all L2s under the L1 are selected
   */
  private checkAllL2sSelected(groupItem: any): boolean {
    // Find the L1 entry
    const l1Entry = this.leaderdropdwnDataSource.find(
      item => item.leader_level_1_msid === groupItem.leader_level_1_msid
    );

    if (!l1Entry || !l1Entry.children) {
      return false;
    }

    // Get all L2 MSIDs under this L1
    const allL2MSIDs = l1Entry.children
      .map(item => item.leader_level_2_msid)
      .filter(id => id !== null && id !== undefined);

    // For this specific L2, check if it's the only one selected
    const isOnlySelectedL2 = allL2MSIDs.length === 1 &&
                              allL2MSIDs[0] === groupItem.leader_level_2_msid;

    return isOnlySelectedL2;
  }

  /**
   * Fetches the leader hierarchy list from the maintenance service.
   * Updates the dropdown data source and handles errors if the API call fails.
   */
  getLeaderHierarchyList() {
    this.showLoader = true;
    this.maintenanceService.getUcmgHierarchyList().subscribe((result: any) => {
      if (result && result.length > 0) {
        this.leaderdropdwnDataSource = this.generateDropdownData(result);
      } else {
        this.leaderdropdwnDataSource = [];
      }
      this.showLoader = false;
    }, (error) => {
      console.error(error);
      this.toaster.error("Error fetching leader hierarchy list", '', {
        timeOut: 10000,
        positionClass: 'toast-top-center'
      });
      this.showLoader = false;
      this.leaderdropdwnDataSource = [];
    });
  }



  getLevelInt(level) {
    if (!level || typeof level !== 'string') {
      console.error('Invalid level format:', level);
      return -1; // Return -1 for invalid input
    }
    // Extract the numeric part of the level string
    const levelNumber = parseInt(level.slice(1), 10);
    // Check if the extracted number is a valid integer
    if (isNaN(levelNumber)) {
      throw new Error("Invalid level format");
    }
    return levelNumber;
  }



  cleanHierarchy(data: any[]): any[] {
    return data.map(level1 => {
      const level1Copy = { ...level1 };
      level1Copy.children = level1.children
        .filter(level2 => level2.leader_level_2_msid !== null)
        .map(level2 => {
          const level2Copy = { ...level2 };
          level2Copy.children = level2.children.filter(
            level3 => level3.leader_level_3_msid !== null
          );
          return level2Copy;
        });
      return level1Copy;
    });
  }


  /**
   * Handles the selection of values in dropdowns.
   * Updates the selected segment list and fetches distinct segments if leaders are selected.
   *
   * @param ev - The event object containing selected data.
   * @param type - The type of selection ('leader' or 'segment' etc..).
   */

  setSelectedValues(ev, type: string) {
    switch (type) {
      case "leader":
        this.selectedLeaders = [];
        this.fetchDistinctSegments(ev);
        this.disableReset = false;
        this.disableSearch = false;
        break;
    }
    switch (ev.type) {
      case "Investment Status":
        this.selectedStatusList = ev.data;
        this.disableReset = false;
        this.disableSearch = false;
        break;
      default:
        if (this.selectedLeaders.length === 0) {
          this.disableReset = true;
          this.disableSearch = true;
        } else {
          this.disableSearch = false;
        }
    }
  }

  /**
   * Updates the `selectedLeaders` array.
   *
   * @param data - The selected leader hierarchy data.
   */

  fetchDistinctSegments(data: any[]) {
    if (!data || data.length === 0) return;

    data.forEach((item) => {
      this.processLevel1(item);
    });
    this.selectedLeadersdetails = data;
  }

  private processLevel1(item: any) {
    const level1Leaders = this.leaderdropdwnDataSource.filter(
      (ele) => ele.leader_level_1_msid === item.leader_level_1_msid && ele.children?.length > 0
    );

    level1Leaders.forEach((level1) => {
      this.processLevel2(level1, item);
    });
  }

  private processLevel2(level1: any, item: any) {
    this.selectedL2Count = 0;
    const level2Leaders = level1.children.filter(
      (child) => child.leader_level_2_msid === item.leader_level_2_msid && child.children?.length > 0
    );
 this.selectedL3Count = 0;
    level2Leaders.forEach((level2) => {
      this.processLevel3(level2, item);
    });
    this.selectedL2Count == level1.children.length ? item.allL2sSelected = true : item.allL2sSelected = false;
  }

  private processLevel3(level2: any, item: any) {
    item.children.forEach((subItem) => {
      const level3Leaders = level2.children.filter(
        (subChild) => subChild.leader_level_3_msid === subItem
      );

      level3Leaders.forEach((level3) => {
        this.addLeaderIfNotExists(item, subItem);
       this.selectedL3Count++;
      });
    });
    if(this.selectedL3Count == level2.children.length){
      item.allL3sSelected = true;
      this.selectedL2Count++;
    } else{
      item.allL3sSelected = false;
    }
  }

  private addLeaderIfNotExists(item: any, subItem: any) {
    const leaderExists = this.selectedLeaders.some(
      (leader) =>
        leader.leader_level_1_msid === item.leader_level_1_msid &&
        leader.leader_level_2_msid === item.leader_level_2_msid &&
        leader.leader_level_3_msid === subItem
    );

    if (!leaderExists) {
      this.selectedLeaders.push({
        leader_level_1_msid: item.leader_level_1_msid,
        leader_level_2_msid: item.leader_level_2_msid,
        leader_level_3_msid: subItem,
      });
    }
  }

  /**
   * Determines whether the search button should be disabled.
   * The button is disabled if any required field (year, segment, status, or leader) is not selected.
   *
   * @returns A boolean indicating whether the search button is disabled.
   */
  searchBtnDisable() {
    return Object.keys(this.selectedYr).length === 0 || this.selectedStatusList.length === 0 || this.selectedLeaders.length === 0 || this.disableSearch === true;
  }

  /**
   * Handles changes to the selected year.
   * Updates the `selectedYr` property with the selected year data.
   *
   * @param event - The event object containing the selected year data.
   */
  onYearChange(event: any) {
    this.disableReset = false;
    this.disableSearch = false;
    this.selectedYr = event.data;
  }
  searchSegmentDetails() {
    this.showKPI = false;
    this.clearKPIValues();
    this.filteredData = null;
    this.showLoader = true; // Show loader
    const requestData = {
      fiscalYear: this.selectedYr?.name,
      investmentStatus: this.getInvstStatus(),
      leader: this.selectedLeaders,
    };
    localStorage.setItem('capitalDemandLeaderSelectedstatus', JSON.stringify(this.selectedStatusList));
    let response = []
    this.maintenanceService.listCapitalDemandUCMGList(requestData, 4).subscribe((result: any) => {
      this.showLoader = false; // Hide loader after response
      if (result.LeaderData) {
        response = result.LeaderData || [];
        this.capitalDemandLeaderResponse = result.LeaderData; //save for later use
        this.extractNames(response);
        const newArr = []
        response.forEach(element => {
          const arrWrapper = [];
          arrWrapper.push(element);
          newArr.push(arrWrapper);
        });
        // Sum Optum Tech Labour for each leader
        for (const arr of newArr) {
          if (arr && arr[0]) {
            this.sumOptumTechLabour(arr[0]);
          }
        }
        this.flattenedArr = [];
        const finalArray = [];
        for (let i = 0; i < newArr.length; i++) {
          //for some reason a wierd case of an array with an obj with null values is coming in, just skip it
          const obj = newArr[i];
          if (obj[0].Leader_L1_Name === null && obj[0].Leader_L1_MSID === null && obj[0].children.length === 0) {
            continue;
          }//end of weird edge case
          finalArray.push(this.transformData(newArr[i], 1));
        }
        this.convertedData = finalArray;
        this.convertedData = this.addExpandedField(this.convertedData);// add expand on each leader so we can add this functionality
        this.convertedData = this.addEditFieldToData(this.convertedData); // add edit field to leader to see if it should be editable
        this.applyHierarchyHighlighting();
        this.applyHierarchyExpansion();
        this.calculateL1sOTTotal();
        this.getDistinctLeaderNames();
        this.oldData = this.convertedData;
        this.filteredData = this.getFilteredData(this.convertedData);
        this.kpidatasource = _.cloneDeep(this.filteredData);
        this.dataSourceDetailsOTLabor = new MatTableDataSource(this.filteredData);
        this.getKPIValues(this.kpidatasource);
        this.expandCollapseAll = this.filteredData && Array.isArray(this.filteredData) && this.filteredData.some((group: any[]) =>
          group.some((leader: { expanded: boolean }) => leader.expanded)
        );
        localStorage.setItem('filteredData', JSON.stringify(this.convertedData));
      } else {
        this.showKPI = false;
        this.filteredData = [];
        this.showLoader = false;
      }
    }, error => {
      console.error(error);
      this.toaster.error("Error fetching capital demand leader data", '', {
         timeOut: 10000, positionClass: 'toast-top-center'
      });
      this.showKPI = false;
      this.filteredData = [];
      this.showLoader = false; // Hide loader after response
    });
    this.disableSearch = true;
  }

  applyHierarchyExpansion() {
    const selectedL3MSIDs = this.selectedLeaders.map(l => l.leader_level_3_msid);

    this.convertedData.forEach(group => {
      group.forEach(leader => {
        if (leader.level === 'L1') {
          const matchedL1 = this.selectedLeadersdetails.filter(l => l.leader_level_1_msid === leader.Leader_MSID);
          const originalData = this.leaderdropdwnDataSource.find(l => l.leader_level_1_msid === leader.Leader_MSID);

          const allL2sSelected = originalData?.children?.length === matchedL1.length;
          const allL3sSelectedForAllL2s = matchedL1.every(l => l.allL3sSelected);

          if (allL2sSelected && allL3sSelectedForAllL2s) {
            leader.expanded = false; // Collapse at L1
          } else {
            leader.expanded = true; // Expand L1
          }
        }

        if (leader.level === 'L2') {
          const matchedL2 = this.selectedLeadersdetails.find(
            l => l.leader_level_2_msid === leader.Leader_MSID
          );

          const parentL1 = this.selectedLeadersdetails.find(
            l => l.leader_level_1_msid === leader.parent_L1_msid
          );
          const originalL1Data = this.leaderdropdwnDataSource.find(
            l => l.leader_level_1_msid === leader.parent_L1_msid
          );

          const allL2sSelected = originalL1Data?.children?.length === this.selectedLeadersdetails.filter(
            l => l.leader_level_1_msid === leader.parent_L1_msid
          ).length;

          if (!allL2sSelected && matchedL2?.allL3sSelected) {
            leader.expanded = false; // Collapse at L2
          } else {
            leader.expanded = true; // Expand L2
          }
        }

        if (leader.level === 'L3') {
          leader.expanded = selectedL3MSIDs.includes(leader.Leader_MSID); // Expand if selected
        }
      });
    });

    this.filteredData = this.getFilteredData(this.convertedData);
    this.dataSourceDetailsOTLabor = new MatTableDataSource(this.filteredData);
  }




  applyHierarchyHighlighting() {
    const selectedL3MSIDs = this.selectedLeaders.map(l => l.leader_level_3_msid);
    let isprevL1Highlighted = '';
    let isprevL2Highlighted = '';
this.convertedData.forEach(group => {
      group.forEach(leader => {
       //selectedLeaderdetails is having the list of selected leaders in l1-l2-listofl3 format, basedon that we have to identify which level of leader was selected by user and have to highlihght that field
       if(leader.level == 'L1'){
        const matchedL1 = this.selectedLeadersdetails.filter(l => l.leader_level_1_msid === leader.Leader_MSID);
        let originalData = this.leaderdropdwnDataSource.find(l => l.leader_level_1_msid === leader.Leader_MSID);
        let allL2sSelected = (originalData?.children?.length || 0) === matchedL1.length;
        let allL3sSelected = matchedL1.filter(l=>l.allL3sSelected).length == matchedL1.length;
        leader.isHighlighted = allL2sSelected && allL3sSelected ? true : false;
        isprevL1Highlighted = leader.isHighlighted;
       }else if(leader.level == 'L2' && !isprevL1Highlighted){
        const l2withallL3selected = this.selectedLeadersdetails.filter(l => l.leader_level_2_msid === leader.Leader_MSID && l.allL3sSelected);
        leader.isHighlighted = l2withallL3selected.length>0 ? true : false;
        isprevL2Highlighted = leader.isHighlighted;
       }else if(leader.level == 'L3' && !isprevL2Highlighted && !isprevL1Highlighted){
        leader.isHighlighted = selectedL3MSIDs.includes(leader.Leader_MSID) ? true : false;
       }
      });
    })

    this.filteredData = this.getFilteredData(this.convertedData);
    this.dataSourceDetailsOTLabor = new MatTableDataSource(this.filteredData);

  }




  getFilteredData(currentData) {
    if (!Array.isArray(currentData)) {
      console.error('Invalid input provided to getFilteredData:', currentData);
      return [];
    }

    const filteredData = [];

    currentData.forEach(group => {
      if (!Array.isArray(group)) {
        console.error('Invalid group in currentData:', group);
        return;
      }

      const filteredGroup = [];
      const expandedFlags = {
        L2: false, L3: false, L4: false, L5: false, L6: false, L7: false, L8: false
      };

      group.forEach(item => {
        if (!item || !item.level) return;

        switch (item.level) {
          case 'L1':
            filteredGroup.push(item);
            expandedFlags.L2 = item.expanded;
            break;
          case 'L2':
            if (expandedFlags.L2) {
              filteredGroup.push(item);
              expandedFlags.L3 = item.expanded;
            }
            break;
          case 'L3':
            if (expandedFlags.L3) {
              filteredGroup.push(item);
              expandedFlags.L4 = item.expanded;
            }
            break;
          case 'L4':
            if (expandedFlags.L4) {
              filteredGroup.push(item);
              expandedFlags.L5 = item.expanded;
            }
            break;
          case 'L5':
            if (expandedFlags.L5) {
              filteredGroup.push(item);
              expandedFlags.L6 = item.expanded;
            }
            break;
          case 'L6':
            if (expandedFlags.L6) {
              filteredGroup.push(item);
              expandedFlags.L7 = item.expanded;
            }
            break;
          case 'L7':
            if (expandedFlags.L7) {
              filteredGroup.push(item);
              expandedFlags.L8 = item.expanded;
            }
            break;
          case 'L8':
            if (expandedFlags.L8) {
              filteredGroup.push(item);
            }
            break;
        }

        // Reset flags if not expanded
        if (!item.expanded && expandedFlags[`L${parseInt(item.level[1]) + 1}`] !== undefined) {
          expandedFlags[`L${parseInt(item.level[1]) + 1}`] = false;
        }

      });

      filteredData.push(filteredGroup);
    });

    return filteredData;
  }


  addEditFieldToData(arr) {
    if (!Array.isArray(arr)) {
      console.error('Input data is not an array:', arr);
      return arr;
    }

    arr.forEach(group => {
      if (Array.isArray(group)) {
        group.forEach((leader, index) => {
          leader.canEdit = false;
          // Check if the leader has no children

          if (index === group.length - 1 || (group[index + 1] && group[index + 1].level <= leader.level)) {
            leader.canEdit = true;
            const leaderMSIDs = this.findLeaderPathByLevelConcat(this.capitalDemandLeaderResponse, leader.level, leader.Leader_MSID);
            if (leaderMSIDs && this.mismatchLeadersMSIDs.length > 0 && this.mismatchLeadersMSIDs.includes(leaderMSIDs)) {
              leader.isHierarchyMismatch = true;
            }
          }
        });
      } else {
        console.error('Group is not an array:', group);
      }
    });

    this.filteredData = this.getFilteredData(arr);
    return arr;
  }

  findLeaderPathByLevelConcat(data: any, targetLevel: string, targetMSID: string): string | null {
    let result: string[] = [];

    function traverse(node: any, level: number, path: string[]): boolean {
      const levelKey = `Leader_L${level}_MSID`;
      if (node[levelKey]) {
        path.push(node[levelKey]);
        if (node[levelKey] === targetMSID && `L${level}` === targetLevel) {
          result = [...path];
          return true;
        }
      }

      if (node.children && node.children.length > 0) {
        for (const child of node.children) {
          const newPath = [...path];
          if (traverse(child, level + 1, newPath)) {
            return true;
          }
        }
      }

      return false;
    }

    for (const l1 of data) {
      if (traverse(l1, 1, [])) {
        break;
      }
    }

    return result.length > 0 ? result.join(' ') : null;
  }

  addExpandedField(data) {
    if (!Array.isArray(data)) {
      console.error('Invalid input provided to addExpandedField:', data);
      return data; // Return the input as-is if it's not an array
    }
    return data.map(group => {
      if (!Array.isArray(group)) {
        console.error('Invalid group in data:', group);
        return group; // Return the group as-is if it's not an array
      }

      return group.map(leader => {
        return {
          ...leader,
          expanded: true
        };
      });
    });

  }

  transformData(arr: any[], curLevel: number): any[] {
    if (!Array.isArray(arr)) {
      console.error('Input data is not an array:', arr);
      return [];
    }

    let levelList: any[] = [];

    arr.forEach(leader => {
      const hierarchy = this.transformDataHelper(leader, curLevel);
      levelList = levelList.concat(hierarchy);
    });

    return levelList;
  }

  transformDataHelper(obj: any, curLevel: number): any[] {
    const curHierarchyList: any[] = [];

    const levelKey = `Leader_L${curLevel}_Name`;
    const msidKey = `Leader_L${curLevel}_MSID`;

    const Leader_Name = obj[levelKey] || '';
    const Leader_MSID = obj[msidKey] || '';

    const { leader_l1_msid, leader_l2_msid, leader_l3_msid } = this.getLeaderHierarchy(
      Leader_MSID,
      obj.Leader_Level || curLevel,
      this.selectedLeaders
    );

    const leaderObj = {
      Leader_Name,
      Leader_MSID,
      level: `L${curLevel}`,
      ucmg_count: obj.ucmg_count || '',
      flagged_ucmg_count: obj.flagged_ucmg_count ?? '',
      remaining_OT: obj.remaining_OT ?? '',
      totalRunRate: obj.totalRunRate ?? '',
      leader_ot_actuals: obj.totalActuals ?? obj.Actuals ?? '',
      leader_ot_allocation: obj.total_OT ?? '',
      leader_variance: (typeof obj.total_OT === 'number' && typeof obj.totalRunRate === 'number') ? (obj.total_OT - obj.totalRunRate) : 0,
      totalOTForecast: obj.totalOTForecast ?? '',
      department_id_name: obj.department_id_name ?? '',
      Optum_Tech_Labour: obj.Optum_Tech_Labour ?? '',
      leader_level: obj.Leader_Level || curLevel,
      edit: false,
      fiscalYear: this.selectedYr?.name,
      leader: this.selectedLeaders,
      leader_l1_msid,
      leader_l2_msid,
      leader_l3_msid,
      parentMSID: obj.parentMSID || null // optional: helps with hierarchy tracing
    };

    curHierarchyList.push(leaderObj);

    // Recursively process children
    if (Array.isArray(obj.children) && obj.children.length > 0) {
      const childHierarchy = this.transformData(obj.children, curLevel + 1);
      curHierarchyList.push(...childHierarchy);
    }

    return curHierarchyList;
  }

  getLeaderHierarchy(Leader_MSID, leader_level, leaderSearchData) {
    let leader_l1_msid = null;
    let leader_l2_msid = null;
    let leader_l3_msid = null;

    if (leader_level === 1) {
      leader_l1_msid = Leader_MSID;
    } else if (leader_level === 2) {
      leader_l2_msid = Leader_MSID;
      const l1Match = leaderSearchData.find(item => item.leader_level_2_msid === Leader_MSID);
      leader_l1_msid = l1Match?.leader_level_1_msid || null;
    } else if (leader_level === 3) {
      leader_l3_msid = Leader_MSID;
      const l2Match = leaderSearchData.find(item => item.leader_level_3_msid === Leader_MSID && item.Leader_Level === 3);
      leader_l2_msid = l2Match?.leader_level_2_msid || null;
      leader_l1_msid = l2Match?.leader_level_1_msid || null;
    }
    return { leader_l1_msid, leader_l2_msid, leader_l3_msid };
  }


  extractNames(data: any[]): void {
    for (const item of data) {
      Object.keys(item).forEach((key) => {
        if (key.startsWith('Leader_L') && key.endsWith('_Name')) {
          this.existingNames.add(item[key]);
        }
      });
      if (item.children?.length) {
        this.extractNames(item.children)
      }
    }
  }

  getDistinctLeaderNames() {
    this.convertedData.forEach(group => {
      group.forEach(leader => {
        if (leader.Leader_Name && !this.leaderNames.includes(leader.Leader_Name)) {
          this.leaderNames.push(leader.Leader_Name);
        }
      });
    });

  }

  calculateL1sOTTotal() {
    if (this.convertedData === undefined) { return; }
    this.L1sTotalOT = 0;
    //for each arr
    this.clearRollUpOTData()
    this.addRollUpOTToData()
    this.convertedData.forEach((heir: any) => {
      heir.forEach((leader: any) => {
        if (leader.level == "L1") {
          this.L1sTotalOT += leader.roll_up_optum_tech || 0;
        }
      });
    });
    this.remainingOptumLabour = 0;
  }

  clearRollUpOTData(): any {
    this.convertedData.forEach(heir => { // for each L1 Heirarchy
      heir.forEach(leader => { //for each leader
        //check if they have roll_up_optum_tech
        if (leader?.roll_up_optum_tech) {
          //if they do clear it
          delete leader.roll_up_optum_tech;
        }
      });
    });
  }


  addRollUpOTToData(): any {
    if (!this.convertedData || !Array.isArray(this.convertedData)) {
      console.error('convertedData is not initialized or is not an array');
      return this.convertedData;
    }
    this.convertedData.forEach((heirIndex, index) => {
      //calculate roll up per heirarchy
      this.calculateRollUpLabor(index, 0);
    });
    return this.convertedData;
  }

  calculateRollUpLabor(heirIndex: any, index: any) {
    if (!this.convertedData || !Array.isArray(this.convertedData)) {
      console.error('convertedData is not initialized or is not an array');
      return;
    }
    if (!this.convertedData[heirIndex] || !this.convertedData[heirIndex][index]) {
      return;
    }
  }


  exportToCsv() {
    if (!this.hasDataToExport()) return;

    const exportData = this.processLeadersForExcel(this.convertedData);
    const dataValues = exportData.map((ele) => this.createExportObject(ele));

    const fileName = 'Optum Tech Labor Split';
    this.exportService.exportToExcel(fileName, [dataValues], ['Optum Tech Labor Split View']);
  }

  private hasDataToExport(): boolean {
    return this.dataSourceDetailsOTLabor.data && this.dataSourceDetailsOTLabor.data.length > 0;
  }

  private createExportObject(ele: any): any {
    return {
      'Leader L1 Name': ele['Leader_L1_Name'] || '',
      'Leader L1 UCMG Count': ele['L1_ucmg_count'] || '',
      'Leader L1 Flagged UCMG Count': ele['L1_flagged_ucmg_count'] || 0,
      'Leader L1 Leader OT Allocation': ele['L1_leader_ot_allocation'] || 0,
      'Leader L1 Leader Run Rate': ele['L1_totalRunRate'] || 0,
      'Leader L1 Leader OT Actuals': ele['L1_leader_ot_actuals'] || 0,
      'Leader L1 Leader Variance': ele['L1_leader_variance'] || 0,
      'Leader L1 MSID': ele['Leader_L1_MSID'] || '',

      'Leader L2 Name': ele['Leader_L2_Name'] || '',
      'Leader L2 MSID': ele['Leader_L2_MSID'] || '',
      'Leader L2 UCMG Count': ele['L2_ucmg_count'] || '',
      'Leader L2 Flagged UCMG Count': ele['L2_flagged_ucmg_count'] || 0,
      'Leader L2 Leader OT Allocation': ele['L2_leader_ot_allocation'] || 0,
      'Leader L2 Leader Run Rate': ele['L2_totalRunRate'] || 0,
      'Leader L2 Leader OT Actuals': ele['L2_leader_ot_actuals'] || 0,
      'Leader L2 Leader Variance': ele['L2_leader_variance'] || 0,

      'Leader L3 Name': ele['Leader_L3_Name'] || '',
      'Leader L3 MSID': ele['Leader_L3_MSID'] || '',
      'Leader L3 UCMG Count': ele['L3_ucmg_count'] || '',
      'Leader L3 Flagged UCMG Count': ele['L3_flagged_ucmg_count'] || 0,
      'Leader L3 Leader OT Allocation': ele['L3_leader_ot_allocation'] || 0,
      'Leader L3 Leader Run Rate': ele['L3_totalRunRate'] || 0,
      'Leader L3 Leader OT Actuals': ele['L3_leader_ot_actuals'] || 0,
      'Leader L3 Leader Variance': ele['L3_leader_variance'] || 0,
    };
  }


  processLeadersForExcel(data: any[]): any[] {
    if (!Array.isArray(data)) {
      console.error('Invalid input provided to processLeadersForExcel:', data);
      return [];
    }

    const result = [];
    data.forEach((L1Hierarchy) => this.processHierarchy(L1Hierarchy, result));
    return result;
  }

  private processHierarchy(L1Hierarchy: any[], result: any[]): void {
    let L1: any, L2: any;
    L1Hierarchy.forEach((leader) => {
      if (leader.level === 'L1') L1 = leader;
      if (leader.level === 'L2') L2 = leader;
      if (leader.level === 'L3') {
        result.push(this.createExcelRow(L1, L2, leader));
      }
    });
  }

  private isLastL3Leader(hierarchy: any[], index: number): boolean {
    return !hierarchy[index + 1] || hierarchy[index + 1].level !== 'L3';
  }

  private createExcelRow(L1: any, L2: any, L3: any): any {
    return {
      Leader_L1_Name: L1?.Leader_Name || '',
      Leader_L1_MSID: L1?.Leader_MSID || '',
      Leader_L2_Name: L2?.Leader_Name || '',
      Leader_L2_MSID: L2?.Leader_MSID || '',
      Leader_L3_Name: L3?.Leader_Name || '',
      Leader_L3_MSID: L3?.Leader_MSID || '',
      L1_ucmg_count: L1?.ucmg_count || '',
      L2_ucmg_count: L2?.ucmg_count || '',
      L3_ucmg_count: L3?.ucmg_count || '',
      L1_flagged_ucmg_count: L1?.flagged_ucmg_count || '',
      L2_flagged_ucmg_count: L2?.flagged_ucmg_count || '',
      L3_flagged_ucmg_count: L3?.flagged_ucmg_count || '',
      L1_leader_ot_allocation: L1?.leader_ot_allocation || '',
      L2_leader_ot_allocation: L2?.leader_ot_allocation || '',
      L3_leader_ot_allocation: L3?.leader_ot_allocation || '',
      L1_totalRunRate: L1?.totalRunRate || '',
      L2_totalRunRate: L2?.totalRunRate || '',
      L3_totalRunRate: L3?.totalRunRate || '',
      L1_leader_ot_actuals: L1?.leader_ot_actuals || '',
      L2_leader_ot_actuals: L2?.leader_ot_actuals || '',
      L3_leader_ot_actuals: L3?.leader_ot_actuals || '',
      L1_leader_variance: L1?.leader_variance || '',
      L2_leader_variance: L2?.leader_variance || '',
      L3_leader_variance: L3?.leader_variance || '',
    };
  }

  getSelectedStatusString() {
    return this.selectedStatusList.map(status => status.name).join(',');
  }

  getSelectedLeaders() {
    return this.selectedLeaders.map(leader => leader.leader_level_3_msid).join(',');
  }

  findLeaderForPayload(e, levelComparingTo, returnType) {
    const curComparingLevel = this.getLevelInt(levelComparingTo);
    const curElementLevel = this.getLevelInt(e.level);

    // Handle cases where levels are equal or curComparingLevel is greater
    if (curComparingLevel > curElementLevel) return null;
    if (curComparingLevel === curElementLevel) {
      return this.getReturnValue(e, returnType);
    }

    // Search for the leader in the converted data
    return this.searchLeaderInConvertedData(e, curComparingLevel, returnType);
  }

  private getReturnValue(e, returnType) {
    return returnType === "msid" ? e.Leader_MSID : e.Leader_Name;
  }

  private searchLeaderInConvertedData(e, curComparingLevel, returnType) {
    for (const group of this.convertedData) {
      const index = this.findElementIndex(group, e);
      if (index !== -1) {
        return this.findLeaderInGroup(group, index, curComparingLevel, returnType);
      }
    }
    return null;
  }

  refresh() {
    this.showKPI = false;
    this.clearKPIValues();
    this.filteredData = null;
    this.disableReset = true;
    this.selectedLeaders = [];
    this.leaderNames = [];
    this.selectedStatusList = [...this.statusList];
    this.selectedYr = this.yearList[0];
    this.selectValues = [];
    this.resetTrigger = this.resetTrigger + 1;
    localStorage.removeItem('filteredData');
    localStorage.removeItem('capitalDemandLeaderSelectedLeaders');
    localStorage.removeItem('capitalDemandLeaderSelectedstatus');
    localStorage.removeItem('capitalDemandLeaderKPIValues');
    localStorage.removeItem('selectedHierarchyItems');
  }

  onToggleChange(isToggled: boolean) {
    this.toggleChanged.emit(isToggled); // Emit the toggle state to the parent
    localStorage.removeItem('filteredData');
    localStorage.removeItem('capitalDemandLeaderSelectedstatus');
    localStorage.removeItem('capitalDemandLeaderKPIValues');
    localStorage.removeItem('selectedHierarchyItems');

  }



  private findElementIndex(group, e) {
    return group.findIndex(item =>
      item.Leader_Name === e.Leader_Name &&
      item.DepartmentIDName === e.DepartmentIDName &&
      item.level === e.level
    );
  }

  private findLeaderInGroup(group, index, curComparingLevel, returnType) {
    for (let j = index; j >= 0; j--) {
      if (this.getLevelInt(group[j].level) === curComparingLevel) {
        return this.getReturnValue(group[j], returnType);
      }
    }
    return null;
  }

  getInvstStatus(){
    // Returns a comma-separated string of uppercased status names from selectedStatusList, or an empty string if none.
      //[{"name": "Active"},{"name": "Inactive"}]
      // selectedStatus list is this right now but I want to return ["ACTIVE","INACTIVE"] format
    let statusArr: any = [];
    if(Array.isArray(this.selectedStatusList) && this.selectedStatusList.length > 0){
        if(this.selectedStatusList){
          statusArr = this.selectedStatusList
            .map(item => item.name.toUpperCase())

        }
    }
    return statusArr;
  }


  generateLink(element: any) {
    const baseUrl = window.location.origin;
    const params: any = { leaderView: 'true' };

    const L1LeaderName = this.findLeaderForPayload(element, 'L1', 'name');
    if (L1LeaderName != null) params.L1LeaderName = L1LeaderName;

    const L1LeaderMSID = this.findLeaderForPayload(element, 'L1', 'msid');
    if (L1LeaderMSID != null) params.L1LeaderMSID = L1LeaderMSID;

    const L2LeaderName = this.findLeaderForPayload(element, 'L2', 'name');
    if (L2LeaderName != null) params.L2LeaderName = L2LeaderName;

    const L2LeaderMSID = this.findLeaderForPayload(element, 'L2', 'msid');
    if (L2LeaderMSID != null) params.L2LeaderMSID = L2LeaderMSID;

    const L3LeaderName = this.findLeaderForPayload(element, 'L3', 'name');
    if (L3LeaderName != null) params.L3LeaderName = L3LeaderName;

    const L3LeaderMSID = this.findLeaderForPayload(element, 'L3', 'msid');
    if (L3LeaderMSID != null) params.L3LeaderMSID = L3LeaderMSID;

    if (element.fiscalYear != null) params.fiscalYear = element.fiscalYear;
    const leader = this.getSelectedLeaders();
    if (leader != null && leader !== '') params.leader = leader;
    const invstStatus = this.getSelectedStatusString();
    if (invstStatus != null && invstStatus !== ''){ params.invstStatus = invstStatus;
      params.selectedStatus = JSON.stringify(this.selectedStatusList);}
    if (element.ucmgSegmentId != null) params.segment = element.ucmgSegmentId;

    this.router.navigate(['/maintenanceV4/Capital-Demand/UCMG-List-View'], { queryParams: params });
  }

  leaderOTAllocationKPI = {
    value: 0,
  };

  leaderRunRateKPI = {
    value: 0,
  };

  leaderVarianceKPI = {
    value: 0,
  };

  clearKPIValues(){
    this.leaderVarianceKPI = {
      value: 0,
    };

    this.leaderRunRateKPI = {
      value: 0,
    };

    this.leaderOTAllocationKPI = {
      value: 0,
    };
  }

  /**
   * Aggregates KPI values from the provided data source.
   * Handles empty or malformed data gracefully.
   */
  getKPIValues(dataInc){
    try {
      //check if data exists
      if(dataInc.length <= 0) { this.showKPI = false; return; }
      //clear previous KPI values so we can update
      this.clearKPIValues();
      this.showKPI = true; //show KPI section
      let data = dataInc;

      //loop ucmgs and calculate totals
      for (let hiers of data) { //hier is an array
        for (let leader of hiers) { //leader is the obj we need
            //totals
            if(leader.isHighlighted == false || leader.isHighlighted == undefined || leader.isHighlighted == null) continue; //skip non selected leaders
            this.leaderOTAllocationKPI.value += leader?.leader_ot_allocation || 0;
            this.leaderRunRateKPI.value += leader?.totalRunRate || 0;
        }
      }
      this.leaderVarianceKPI.value = this.leaderOTAllocationKPI.value - this.leaderRunRateKPI.value;
      localStorage.setItem('capitalDemandLeaderKPIValues', JSON.stringify({
        leaderOTAllocationKPI: this.leaderOTAllocationKPI,
        leaderVarianceKPI: this.leaderVarianceKPI,
        leaderRunRateKPI: this.leaderRunRateKPI
      }) );
    } catch (err) {
      console.error('Error in getKPIValues:', err, dataInc);
      this.showKPI = false;
    }
  }

  /*
   * Recursively sums Optum_Tech_Labour from L3 up to L2 and L1.
   */
  sumOptumTechLabour(node: any): number {
    try {
      if (!node || typeof node !== 'object') return 0;
      // If this is an L3 node (leaf), just return its value (or 0)
      if (!node.children || !Array.isArray(node.children) || node.children.length === 0) {
        return Number(node.Optum_Tech_Labour) || 0;
      }
      // Otherwise, sum all children's Optum_Tech_Labour
      let total = 0;
      for (const child of node.children) {
        total += this.sumOptumTechLabour(child);
      }
      node.Optum_Tech_Labour = total;
      return total;
    } catch (err) {
      console.error('Error in sumOptumTechLabour:', err, node);
      return 0;
    }
  }

}